import * as React from "react";
import {getValidChildren} from "../../../users/HierarchyVisibilityUtils";
import {VeboxExpandable} from "../../expadable/VeboxExpandable";
import {expandIconWidth, itemIndentation} from "../VeboxTreeView";

export interface VeboxTreeViewItemProps {
    label?: string | JSX.Element | ((checked: boolean) => JSX.Element);
    expanded?: boolean;
    level?: number;
    removeInputSpace?: boolean
}

export const VeboxTreeViewItem: React.FC<VeboxTreeViewItemProps & React.HTMLAttributes<any>> = ({
                                                                                                    className,
                                                                                                    children,
                                                                                                    removeInputSpace,
                                                                                                    level,
                                                                                                    label,
                                                                                                    expanded,
                                                                                                    ...rest
                                                                                                }) => {
    const hasChildren = getValidChildren(children).length > 0;

    const head = (expand, setExpand) => {

        const toggle = () => setExpand(!expand);

        return (
            <div {...rest} className={"vebox-tree-row " + (className ?? "")}>
                <div className={"flx-no-shrink"} style={{width: itemIndentation * (level ?? 0)}}/>
                {expand
                    ? <span
                        className="material-icons clickable"
                        onClick={hasChildren ? toggle : undefined}
                    >expand_less</span>
                    : <span
                        className="material-icons clickable"
                        onClick={hasChildren ? toggle : undefined}
                    >expand_more</span>
                }
                {label}
            </div>
        );
    }

    return (
        hasChildren
            ? (
                <VeboxExpandable collapsed={head} expanded={expanded}>
                    {React.Children.toArray(children).map((child: any, i) => {
                        return child ? React.cloneElement<VeboxTreeViewItemProps>(
                            child,
                            {
                                ...child.props,
                                level: (level ?? 0) + 1
                            }
                        ) : undefined;
                    })}
                </VeboxExpandable>
            ) : (
                <div {...rest} className={"vebox-tree-row " + (className ?? "")}>
                    <div
                        className={"flx-no-shrink"}
                        style={{width: itemIndentation * (level ?? 0) + (removeInputSpace ? 0 : expandIconWidth)}}
                    />
                    {label}
                </div>
            )
    );
}